export const DEFAULT_OFFERS_LINK = 'DEFAULT_OFFERS';
export const FAVOURITES_OFFERS_LINK = 'FAVOURITES_OFFERS';
export const MYWAITROSE_OFFERS_LINK = 'MYWAITROSE_OFFERS';
